import React from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LinkIcon from '@mui/icons-material/Link';
import BlockIcon from '@mui/icons-material/Block';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CalculateIcon from '@mui/icons-material/Calculate';
import TurnedInIcon from '@mui/icons-material/TurnedIn';

export function GradienSettingsIcon(props) {
  const { fontSize=30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00464e" />
            <stop offset="100%" stopColor="#1fa37c" />
          </linearGradient>
        </defs>
      </svg>
      <SettingsIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#my_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienRemoveRedEyeIcon(props) {
  const { fontSize=25 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00464e" />
            <stop offset="100%" stopColor="#1fa37c" />
          </linearGradient>
        </defs>
      </svg>
      <RemoveRedEyeIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#my_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienWarningIcon(props) {
  const { fontSize=30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="warning_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ed6c02" />
            <stop offset="100%" stopColor="#ff9800" />
          </linearGradient>
        </defs>
      </svg>
      <WarningIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#warning_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienCheckCircleIcon(props) {
  const { fontSize = 30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="checkcircle_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#049dd0" />
            <stop offset="100%" stopColor="#1fa37c" />
          </linearGradient>
        </defs>
      </svg>
      <CheckCircleIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#checkcircle_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienFirstMonthIcon(props) {
  const { fontSize=30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          {/* gradient */}
          <linearGradient id="firstmonth_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#d32f2f" />
            <stop offset="100%" stopColor="#ef5350" />
          </linearGradient>

          {/* shadow filter */}
          <filter id="firstmonth_shadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="2" dy="2" stdDeviation="2" floodColor="rgba(0,0,0,0.5)" />
          </filter>
        </defs>
      </svg>

      <TurnedInIcon
        sx={{
          fontSize: fontSize,
          fill: "url(#firstmonth_gradient)",
          filter: "url(#firstmonth_shadow)", // 👈 apply shadow
        }}
      />
    </React.Fragment>
  );
}

export function GradienCancelIcon(props) {
  const { fontSize=30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="cancel_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#d32f2f" />
            <stop offset="100%" stopColor="#ef5350" />
          </linearGradient>
        </defs>
      </svg>
      <CancelIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#cancel_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienBlockIconIcon(props) {
  const { fontSize=30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="cancel_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#d32f2f" />
            <stop offset="100%" stopColor="#ef5350" />
          </linearGradient>
        </defs>
      </svg>
      <BlockIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#cancel_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienCancel2Icon(props) {
  const { fontSize=30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="cancel2_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#bdbdbd" />
            <stop offset="100%" stopColor="#9e9e9e" />
          </linearGradient>
        </defs>
      </svg>
      <CancelIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#cancel2_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienBorderColorIcon(props) {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="borderColor_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00464e" />
            <stop offset="100%" stopColor="#1fa37c" />
          </linearGradient>
        </defs>
      </svg>
      <BorderColorIcon
        {...props}
        sx={{
          fontSize: 20, // Adjust the size of the icon
          fill: 'url(#borderColor_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienListAltIcon(props) {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="borderColor_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00464e" />
            <stop offset="100%" stopColor="#1fa37c" />
          </linearGradient>
        </defs>
      </svg>
      <ListAltIcon
        {...props}
        sx={{
          fontSize: 20, // Adjust the size of the icon
          fill: 'url(#borderColor_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienDeleteIcon(props) {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="delete_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#d32f2f" />
            <stop offset="100%" stopColor="#ef5350" />
          </linearGradient>
        </defs>
      </svg>
      <DeleteIcon
        {...props}
        sx={{
          fontSize: 20, // Adjust the size of the icon
          fill: 'url(#delete_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienInFoIcon(props) {
  const { fontSize=30 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="info_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#4fc3f7" />
            <stop offset="100%" stopColor="#0288d1" />
          </linearGradient>
        </defs>
      </svg>
      <InfoIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#info_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienReceiptLongIcon(props) {
  const { fontSize=25 } = props;
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="cancel_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#d32f2f" />
            <stop offset="100%" stopColor="#ef5350" />
          </linearGradient>
        </defs>
      </svg>
      <ReceiptLongIcon
        sx={{
          fontSize, // Adjust the size of the icon
          fill: 'url(#cancel_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienLinkIcon(props) {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="borderColor_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00464e" />
            <stop offset="100%" stopColor="#1fa37c" />
          </linearGradient>
        </defs>
      </svg>
      <LinkIcon
        {...props}
        sx={{
          fontSize: 20, // Adjust the size of the icon
          fill: 'url(#borderColor_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}

export function GradienCalculateIcon(props) {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="calculate_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#424242" />
            <stop offset="100%" stopColor="#757575" />
          </linearGradient>
        </defs>
      </svg>
      <CalculateIcon
        {...props}
        sx={{
          fontSize: 20, // Adjust the size of the icon
          fill: 'url(#calculate_gradient)', // Apply gradient to the stroke
        }}
      />
    </React.Fragment>
  );
}